/**
 * Native BarcodeDetector support flag + type shim.
 *
 * Kept out of the component file so the modal can be Fast-Refresh-friendly
 * (a file that exports a component shouldn't also export constants).
 *
 * `BarcodeDetector` + `navigator.mediaDevices` are Chromium-only (Chrome on
 * Android ≥83) and require a secure context (HTTPS / localhost). lib.dom
 * doesn't ship the types yet, so we declare the slice we use.
 */

interface BarcodeDetectorResult {
  rawValue: string;
}
export interface BarcodeDetectorLike {
  detect(source: HTMLVideoElement): Promise<BarcodeDetectorResult[]>;
}
interface BarcodeDetectorConstructor {
  new (options?: { formats?: string[] }): BarcodeDetectorLike;
}
declare global {
  interface Window {
    BarcodeDetector?: BarcodeDetectorConstructor;
  }
}

/** True only where the native camera scanner can actually run (feature-detect). */
export const cameraScanSupported =
  typeof window !== "undefined" && "BarcodeDetector" in window;
